import React from 'react';
import { Navigate } from 'react-router-dom';
import { getCookieValue } from '../../App';

interface Props {
  children: React.ReactNode;
  admin?: boolean;
}

const PublicRoute: React.FC<Props> = ({ children }) => {
  const isToken = getCookieValue('token');
  if (isToken) {
    return <Navigate to='/dashboard' />;
  }
  return <>{children}</>;
};

const ProtectedRoute: React.FC<Props> = ({ children, admin = true }) => {
  const isToken = getCookieValue('token');
  if (!isToken) {
    return <Navigate to='/' />;
  }
  if (!admin) {
    return <Navigate to='/dashboard' />;
  }
  return <>{children}</>;
};

export { ProtectedRoute, PublicRoute };
